import IndexGrid, { EmptyMessage } from './IndexGrid';
import * as SubParts from './IndexGridCells';
// eslint-disable-next-line import/no-cycle
import Search from './SearchHeader';

const arrayToColumns = arr => arr.map(key => ({ key, display: key }));

export default Object.assign(IndexGrid, SubParts, { EmptyMessage, arrayToColumns, Search });
